import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { format, getConnectorV1Name } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { TabularTypeDataset } from './tabular-type.dataset';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';
import { SalesforceLinkedService } from '../linkedservice/salesforce.linkedservice';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.salesforceDataset,
    disabled: isTridentInIframe(),
    display: [
        format(shellStringResources.ModelName_DatasetTemplate,
            getConnectorV1Name(shellStringResources.Salesforce_DisplayText)),
        format(shellStringResources.ModelName_DatasetsTemplate,
            getConnectorV1Name(shellStringResources.Salesforce_DisplayText))
    ],
    constraints: {
        linkedService: {
            model: SalesforceLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SalesforceDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
